var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "App" }, [
    _c("h1", { staticClass: "App__title" }, [
      _c("code", { staticClass: "App__name" }, [_vm._v(_vm._s(_vm.name))]),
      _vm._v("\n    Examples\n  "),
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "App__section Section" },
      [
        _c("h2", { staticClass: "Section__title" }, [_vm._v("1. Simple")]),
        _vm._v(" "),
        _c("simple"),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "App__section Section" },
      [
        _c("h2", { staticClass: "Section__title" }, [_vm._v("2. IsRange")]),
        _vm._v(" "),
        _c("is-range"),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "App__section Section" },
      [
        _c("h2", { staticClass: "Section__title" }, [
          _vm._v("3. showDisabledDays"),
        ]),
        _vm._v(" "),
        _c("show-disabled-days"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }